import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { consumeCueSelectedOpenings } from '@/utils/cue-handoff';
import { wxCopilotContextManager } from '@/utils/wx-copilot-context-manager';

export function useWxCopilotPageContext(mountId = 'wx-copilot-root') {
  const location = useLocation();

  useLayoutEffect(() => {
    const url = `${location.pathname}${location.search}${location.hash}`;
    wxCopilotContextManager.sendPageContext(url, mountId);
    // Openings staged by the freemium wizard before leaving `/post-job`.
    const stagedOpenings = consumeCueSelectedOpenings();
    if (stagedOpenings) {
      wxCopilotContextManager.setOpeningsContext(stagedOpenings);
    }
  }, [location, mountId]);

  useEffect(() => {
    return () => {
      wxCopilotContextManager.setOpeningsContext(undefined);
    };
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      wxCopilotContextManager.cleanup();
    };
  }, []);
}
